// import { useCreateClientMutation } from 'actions/dossiers/mutations';
import { useCreateOcrMutation } from 'actions/orc/mutations';
import { useGetOcrQuery } from 'actions/orc/queries';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaRegTrashAlt } from 'react-icons/fa';
import { GoEye } from 'react-icons/go';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import HeaderFirst from 'utils/HeaderFirst';
import TableLoader from 'components/Loader/TableLoader';

const Facture = () => {
  const [creationFacture, { isLoading: isCreating }] = useCreateOcrMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { clientID } = useParams();
  const { data: getDataFacture, isLoading, isFetching } = useGetOcrQuery(
    { dossier_id: clientID },
    { skip: !clientID }
  );

  let totalMontantTotal = 0;

  getDataFacture?.data?.forEach((facture) => {
    totalMontantTotal += facture?.montant_total || 0;
  });

  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    if (isSubmitting || isCreating) return;
    if (!data.image || !data.image[0]) {
      toast.warning('Veuillez sélectionner une image de facture.');
      return;
    }

    const formData = new FormData();
    formData.append('image', data.image[0]);
    formData.append('dossier_id', clientID);

    setIsSubmitting(true);
    try {
      await creationFacture(formData).unwrap();
      toast.success('Création facture réussie !');
      reset();
    } catch (error) {
      toast.warning('Échec lors de l\'extraction de la facture !');
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const nom = (
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">Factures</h4>
      <span className="nbrDossier">{getDataFacture?.count || getDataFacture?.data?.length || 0}</span>
    </div>
  );

  const description = <div>Extraire les données de vos Factures</div>;

  return (
    <div
      className="global"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div
        className="header mb-3"
        style={{
          backgroundColor: 'white',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        <HeaderFirst nom={nom} description={description} />
      </div>
      <form
        action=""
        method="post"
        style={{ padding: '15px' }}
        encType="multipart/form-data"
        onSubmit={handleSubmit(onSubmit)}
      >
        <input type="hidden" />
        <div className="row w-100 gap-4 align-items-center justify-content-between">
          <div className="w-50">
            <div className="mb-3">
              <input
                type="file"
                name="image"
                accept="image/*,application/pdf"
                className="form-control"
                {...register('image', { required: 'Nom obligatoire' })}
              />
            </div>
            <button
              type="submit"
              className="btn btn-outline-dark d-inline-flex align-items-center"
              style={{
                borderRadius: '31px',
                border: '1px solid #AEAEAE',
                padding: '8px 16px',
              }}
              disabled={isSubmitting || isCreating}
            >
              {(isSubmitting || isCreating) && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
              )}
              <span style={ajoutFou}>
                {isSubmitting || isCreating ? 'Extraction en cours...' : '+ Extraire la facture'}
              </span>
            </button>
          </div>
        </div>
      </form>
      <div className="mb-4 mt-3 py-0" style={{ padding: '15px' }}>
        La somme totale de vos factures:{' '}
        <span style={{ fontWeight: '700' }}>{totalMontantTotal} Fcfa</span>
      </div>

      <div>
        {(isLoading || (isFetching && !getDataFacture)) ? (
          <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des factures..."
              subMessage="Récupération des documents et des analyses OCR"
              minHeight="240px"
            />
          </div>
        ) : (
          <div className="mx-lg-3 text-white">
            <table className="table text-white">
              <thead>
                <tr className="text-black">
                  <th scope="col">ID</th>
                  <th scope="col">date d&lsquo;emission</th>
                  <th scope="col">date d&lsquo;échéance</th>
                  <th scope="col">Total facture</th>
                  <th scope="col">Détails</th>
                </tr>
              </thead>
              <tbody>
                {getDataFacture?.data && getDataFacture.data.length > 0 ? (
                  getDataFacture.data.map((facture) => (
                    <tr key={facture?.facture_ID} className="factures_row">
                      <th scope="row" className="pt-4">
                        {facture?.facture_ID}
                      </th>
                      <td className="pt-4">{facture?.date_emission}</td>
                      <td className="pt-4">{facture?.date_echeance}</td>
                      <td className="pt-4">{facture?.montant_total} Fcfa</td>
                      <td className="pt-4">
                        <a href={`${facture?.facture_ID}`}>
                          <GoEye className="text-black fs-5" title="Détail" />
                        </a>
                        <FaRegTrashAlt
                          className="text-danger mx-2 fs-5"
                          title="Archiver"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted py-4">
                      Aucune facture extraite pour le moment.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
const ajoutFou = {
  fontFamily: 'Montserrat',
  fontWeight: '600',
  fontSize: '13px',
};

export default Facture;

